import ContentScreen from '@/components/ContentScreen';
import Loader from '@/components/Loader';
import Constants from '@/Constants';
import { ContentRequest } from '@/models/ContentRequest';
import { CourseRequest } from '@/models/CourseResquest';
import { Lesson } from '@/models/Lesson';
import PageNotFound from '@/pages/PageNotFound/PageNotFound';
import { ApplicationState } from '@/store';
import { getContentRequest, setCurrentContent } from '@/store/item/action';
import { getCourseStudentViewRequest } from '@/store/list/action';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const LessonPage: React.FC = () => {
    const dispatch = useDispatch();

    const { courseId, lessonId } = useParams<{ courseId: string; lessonId: string }>();

    const { personId, course, loading } = useSelector((state: ApplicationState) => ({
        personId: state.identity.data.person.id,
        course: state.lists.currentData.course || {},
        loading: state.lists.loading,
    }));

    const [hasLesson, setHasLesson] = useState<boolean>(false);

    useEffect(() => {
        dispatch(
            getCourseStudentViewRequest({ personId, courseId: parseInt(courseId || '0'), moduleId: Constants.PLAYLIST_MODULE_ID } as CourseRequest),
        );
    }, []);

    useEffect(() => {
        if (course && course.lessons) {
            const lessonIdAsNumber = parseInt(lessonId || '0');
            const lesson: Lesson | undefined = course.lessons.find((lesson: Lesson) => lesson.id === lessonIdAsNumber);

            if (lesson) {
                setHasLesson(true);
                dispatch(setCurrentContent(lesson.content));
                dispatch(getContentRequest({ personId, contentId: lesson.content.id } as ContentRequest));
            }
        }
    }, [course.id]);

    const Components = (loading && <Loader />) || (hasLesson && !loading && <ContentScreen />) || <PageNotFound />;

    return Components;
};

export default LessonPage;
